import {
  Box,
  Button,
  Flex,
  Grid,
  Heading,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Text,
} from '@chakra-ui/core';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import BidenFace from '../../assets/biden_face.svg';
import TrumpFace from '../../assets/trump_face.svg';
import AmountInput from '../../components/AmountInput';
import { formatNumber, getBTCValue } from '../../utils/Utils';

const BTC_TO_SATS = 100000000;
const MIN_BET = 150000;
const MAX_BET = 1500000;

const BetOddsElection = ({
  prediction,
  betAmount,
  setBetAmount,
  betOdds,
  setBetOdds,
  onBack,
  onNext,
}) => {
  const [dummyBetAmount, setDummyBetAmount] = useState(betAmount / BTC_TO_SATS);
  const [betAmountError, setBetAmountError] = useState(false);
  const [betAmountCounterError, setBetAmountCounterError] = useState(false);

  const validateInputs = () => {
    const betAmountCounter = betAmount * betOdds;
    let error = false;

    if (betAmount > MAX_BET || betAmount < MIN_BET) {
      setBetAmountError(true);
      error = true;
    }

    if (betAmountCounter > MAX_BET || betAmountCounter < MIN_BET) {
      setBetAmountCounterError(true);
      error = true;
    }

    return !error;
  };

  useEffect(() => {
    setBetAmountCounterError(false);
    setBetAmountError(false);
    setBetAmount(dummyBetAmount * BTC_TO_SATS);
  }, [dummyBetAmount, setBetAmount]);

  return (
    <>
      <Heading size="sm" as="h4" textAlign="center" mb={8}>
        You are betting that the{' '}
        <Text as="span" textTransform="capitalize">
          {prediction}
        </Text>{' '}
        party will win the US election on Nov. 3rd, 2020.
      </Heading>
      <Grid
        gridTemplateAreas='"tl . tr" "bl bc br"'
        w="full"
        mx="auto"
        gap="8px 0px"
      >
        <Box gridArea="tl" textAlign="center">
          <Heading size="md" mb={1}>
            Republican Win
          </Heading>
          <Image src={TrumpFace} mx="auto" />
        </Box>

        <Box gridArea="tr" textAlign="center">
          <Heading size="md" mb={1}>
            Democrat Win
          </Heading>
          <Image src={BidenFace} mx="auto" />
        </Box>

        <Box gridArea={prediction === 'republican' ? 'bl' : 'br'}>
          <Text mb={2} textAlign="center" fontWeight="bold">
            Your Bet Amount
          </Text>
          <Box mx="auto" w="fit-content">
            <AmountInput
              unit="btc"
              setUnit={() => {}}
              amount={dummyBetAmount}
              isInvalid={betAmountError}
              setAmount={(amount) => {
                console.log(amount);
                setDummyBetAmount(amount);
              }}
            />
            <Text
              fontSize="10px"
              fontStyle="italic"
              mt="2px"
              color={betAmountError ? 'red.400' : 'gray.600'}
            >
              min: 0.0015 to max: 0.015 BTC
            </Text>
          </Box>
        </Box>

        <Box gridArea="bc">
          <Text mb={2} textAlign="center" fontWeight="bold">
            Set Bet Odds
          </Text>
          <Box mx="auto" w="fit-content">
            <NumberFormat
              customInput={Input}
              spellCheck="false"
              width="6rem"
              textAlign="center"
              placeholder="1 : 1"
              value={betOdds}
              onValueChange={(e) => {
                setBetOdds(e.floatValue);
              }}
              // flip direction depending on prediction
              {...(prediction === 'republican'
                ? {
                    prefix: '1 : ',
                  }
                : {
                    suffix: ' : 1',
                  })}
              border="solid 1px #979797"
              thousandSeparator={true}
            />
          </Box>
        </Box>

        <Box gridArea={prediction === 'republican' ? 'br' : 'bl'}>
          <Text mb={2} textAlign="center" fontWeight="bold">
            Counterparty Bet Amount
          </Text>
          <Box mx="auto" w="fit-content">
            <InputGroup>
              <NumberFormat
                isInvalid={betAmountCounterError}
                customInput={Input}
                spellCheck="false"
                value={+(betOdds * dummyBetAmount).toFixed(8)}
                isReadOnly
                bg="#F6F6F6"
                width="12rem"
                suffix=" BTC"
                thousandSeparator={true}
              />
              <InputRightElement
                width="fit-content"
                pr="2"
                color="gray.600"
                whiteSpace="nowrap"
              >
                ${formatNumber(getBTCValue(betOdds * dummyBetAmount || 0))} USD
              </InputRightElement>
            </InputGroup>
            <Text
              fontSize="10px"
              fontStyle="italic"
              mt="2px"
              color={betAmountCounterError ? 'red.400' : 'gray.600'}
            >
              min: 0.0015 to max: 0.015 BTC
            </Text>
          </Box>
        </Box>
      </Grid>

      <Flex
        justifyContent="center"
        bg="#f5f6f9"
        borderRadius="4px"
        p={1}
        mx="auto"
        width="fit-content"
        whiteSpace="nowrap"
        minW="65%"
        my={6}
        fontSize="sm"
        fontWeight="500"
      >
        Your Estimated Potential Profit:
        <Text ml={4}>
          {+(betOdds * dummyBetAmount).toFixed(8)} BTC
          <Text as="span" color="gray.400" ml={4}>
            ${formatNumber(getBTCValue(betOdds * dummyBetAmount || 0))} USD
          </Text>
        </Text>
      </Flex>

      <Flex flexDir="row" mt={4}>
        <Button leftIcon={<ChevronLeftIcon />} onClick={onBack}>
          Go Back
        </Button>
        <Button
          ml="auto"
          colorScheme="blue"
          rightIcon={<ChevronRightIcon />}
          onClick={() => {
            validateInputs() && onNext();
          }}
        >
          Bet Overview
        </Button>
      </Flex>
    </>
  );
};

const BetOdds = (props) => {
  return <BetOddsElection {...props} />;
};

export default BetOdds;
